// src/components/VideoPromotionLahav.js
import React from "react";
import { Box, VStack } from "@chakra-ui/react";
import { Colors } from "../../../../static/static";

function VideoPromotionLahav() {
  return (
    <Box
      id="videoPromotionLahav"
      textAlign="center"
      borderRadius="lg"
      boxShadow="lg"
      className="videoPromotionLahav"
      bg={Colors.bgBlue}
      display={{ base: 'block', md: 'none' }} 
    >
      <VStack spacing={4}>
        <Box
          width={{ base: "100%", md: "100%" }}
          height={{ base: "40vh", md: "45vh" }}
        >
          <iframe
            width="100%"
            height="100%"
            src="https://youtube.com/embed/l9SCIsbX7Mc?si=MeM3ILzO0qAJqc7R"
            title="איך לפצח את סודות הנגינה המסובכת"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe>
        </Box>
      </VStack>
    </Box>
  );
}

export default VideoPromotionLahav;
